// @flow

import React from 'react';
import { FormattedMessage } from 'react-intl';
import messages from '../messages';

export const NAME = 'gross-rent-change-floor-plans';

export const HEADER_MESSAGE_KEYS = [
  'floorPlan',
  'bedsBath',
  'grossRent',
  'utilityAllowance',
  'createdOn',
  'createdBy',
];

export const transparentRowSx = {
  backgroundColor: 'transparent !important',
};

export const headCellSx = {
  borderBottom: 'none',
  paddingTop: 0,
};

export const bodyCellSx = {
  borderBottom: 'none',
};

export const tableContainerSx = {
  width: '100%',
  overflowX: 'auto',
};

export const tableSx = {
  width: '100%',
  minWidth: 720,
};

export const HEADERS = [
  {
    id: 'floorPlanName',
    label: <FormattedMessage {...messages.floorPlan} />,
    sortable: false,
    searchable: false,
    dataType: 'string',
  },
  {
    id: 'bedsBath',
    label: <FormattedMessage {...messages.bedsBath} />,
    sortable: false,
    searchable: false,
    dataType: 'string',
  },
  {
    id: 'grossRent',
    label: <FormattedMessage {...messages.grossRent} />,
    sortable: false,
    searchable: false,
    dataType: 'number',
  },
  {
    id: 'utilityAllowance',
    label: <FormattedMessage {...messages.utilityAllowance} />,
    sortable: false,
    searchable: false,
    dataType: 'number',
  },
  {
    id: 'createdOn',
    label: <FormattedMessage {...messages.createdOn} />,
    sortable: false,
    searchable: false,
    dataType: 'date',
  },
  {
    id: 'createdBy',
    label: <FormattedMessage {...messages.createdBy} />,
    sortable: false,
    searchable: false,
    dataType: 'string',
  },
];

export const PROPERTY_PATH_MAP = {
  floorPlanName: {
    path: 'floorPlanName',
    dataType: 'string',
  },
  bedsBath: {
    path: 'bedsBath',
    dataType: 'string',
  },
  grossRent: {
    path: 'grossRent',
    dataType: 'number',
  },
  utilityAllowance: {
    path: 'utilityAllowance',
    dataType: 'number',
  },
  createdOn: {
    path: 'createdAt',
    dataType: 'date',
  },
  createdBy: {
    path: 'createdByName',
    dataType: 'string',
  },
};
